export const locationOptions = [
  { id: 1, name: "Training Location" },
  { id: 2, name: "Career Location" },
];
